import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { IOverlayLoaderStore } from '../../../common/OverlayLoader.store';
import { ICurrentWorkspaceStore } from '../../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { IProjectOverviewBl } from './projectOverview.bl';
import { ReviewOverview } from './ReviewOverview';

export const ReviewOverviewWidgetContainer = observer((): ReactElement => {
  const { store } = useInjection(IProjectOverviewBl.$);
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const { projectId } = useParams<{ projectId: string }>();

  return (
    <ReviewOverview
      isLoading={overlayLoaderStore.isSpinnerVisible('project-overview')}
      toReviewCount={store.toReviewCount}
      acceptedCount={store.acceptedCount}
      rejectedCount={store.rejectedCount}
      projectId={projectId}
      workspaceId={currentWorkspaceStore.currentWorkspace.id}
    />
  );
});
